import axios, { AxiosResponse } from "axios";
import { IService } from "../models/service";
import { ISearchParams, searchParamsInit } from "../models/searchParams";
import { ApiSearchResponse } from "../models/common";

export const addService = async (service: IService): Promise<AxiosResponse<IService>> => {
    return await axios.post("/dispatcher/service", service);
};

export const changeService = async (service: IService): Promise<AxiosResponse<IService>> => {
    return await axios.patch("/dispatcher/service", service);
};

export const deleteService = async (id: string): Promise<AxiosResponse<string>> => {
    return await axios.delete(`/dispatcher/service/${id}`);
};

export const getService = async (id: string): Promise<AxiosResponse<IService>> => {
    return await axios.get(`/dispatcher/service/${id}`);
};

export const searchService = async (
    searchParams: ISearchParams = searchParamsInit,
): ApiSearchResponse<IService> => {
    return await axios.post("/dispatcher/service/search", searchParams);
};

export const changeServiceInvoice = async (
    serviceId: string,
    invoiceId: number | null,
): Promise<AxiosResponse<IService>> => {
    return await axios.patch(`/dispatcher/service/changeInvoice`, {
        id: serviceId,
        invoiceId: `${invoiceId}`,
    });
};

export const changeServiceBooking = async (
    serviceId: string,
    bookingId: number | null,
): Promise<AxiosResponse<IService>> => {
    return await axios.patch(`/dispatcher/service/changeBooking`, {
        id: serviceId,
        bookingId: `${bookingId}`,
    });
};
